import React, { memo } from 'react';
import { View, StyleSheet } from 'react-native';
import { rem } from 'design-system/values';
import IconPlus from 'design-system/icons/IconPlus';
import IconCircle from 'design-system/icons/IconCircle';
import { SettingsItem } from 'design-system/SettingsItem';
import useColors from 'hooks/useColors';
import { useAppSelector } from 'store/hooks';
import { selectTradingAccount } from '../reducers/selectors';
import { isWeb } from '../../../constants';
const DiversifyPortfolioBtn = ({ onPress }) => {
    const colors = useColors();
    const tradingAccount = useAppSelector(selectTradingAccount);
    if (tradingAccount && tradingAccount.isAlpaca) {
        return null;
    }
    return (<SettingsItem onPress={onPress} title="Add a fund or ETF" style={styles.createNewListButton} description="Diversify your portfolio further" renderIcon={() => (<View style={styles.iconContainer}>
          <IconCircle width={44} height={44}>
            <IconPlus color={colors.text.brand}/>
          </IconCircle>
        </View>)}/>);
};
export default memo(DiversifyPortfolioBtn);
const styles = StyleSheet.create({
    createNewListButton: {
        margin: 0,
        padding: rem(16),
        // The card adds 8px on web, so the icon lines up 16px in with the fund rows below
        ...(isWeb && { marginHorizontal: 0, paddingHorizontal: rem(8) }),
    },
    iconContainer: {
        marginRight: rem(16),
    },
});
